<div fxLayout="column">
    <div fxLayout="row" fxLayoutAlign="space-between center" style="margin:2%">
        <div>
            <label class="page-header-title">Documents & Policies</label>
        </div>

    </div>
    <mat-card fxLayout="column" style="margin: 2% 3% 0% 2%" fxLayoutAlign="start center">
        <div fxLayout="column">
            <div fxLayoutAlign="start center" class="policies-title">
                <label class="policies-label">Policies</label>

            </div>
            <div fxLayoutAlign="center center">
                <div class="document-container">
                    <label class="policies-sub-label" (click)="goToLink('https://swiftchat.ai/securityandprivacy/swiftchat-business-terms-of-service/')">SwiftChat Business Terms of Service</label>
                    <mat-icon class="mat-icon">
                        <span class="material-symbols-outlined">
                            north_east
                            </span>
                    </mat-icon>
                </div>
                
            </div>
        </div>
        <div fxLayout="column">
            <div fxLayout="row" fxLayoutAlign="start center" class="policies-title">
                <label class="policies-label">Documents</label>

            </div>
            <div fxLayout="column">
            <div class="document-container">
                <label class="documents-sub-label" (click)="goToLink('https://swiftchat.ai/swiftchatapp/swiftchat-platform-for-developers-and-businesses')">Swiftchat App Development</label>
                <mat-icon class="mat-icon">
                    <span class="material-symbols-outlined">
                        north_east
                        </span>
                </mat-icon>
            </div>
            <div class="document-container">
                <label class="documents-sub-label" (click)="goToLink('https://swiftchat.ai/swiftchatbusinessapi/overview')">Swiftchat Business API</label>
                <mat-icon class="mat-icon">
                    <span class="material-symbols-outlined">
                        north_east
                        </span>
                </mat-icon>
            </div>
            <div class="document-container">
                <label class="documents-sub-label" (click)="goToLink('https://swiftchat.ai/securityandprivacy/swiftchat-legal-definitions-2')">Security and Privacy for Businesses</label>
                <mat-icon class="mat-icon">
                    <span class="material-symbols-outlined">
                        north_east
                        </span>
                </mat-icon>
            </div> 
            </div>
        </div>

    </mat-card>

</div>